<wilson-page-frame-v2>
  <ng-container headerContent>
    <div class="d-flex gap-2">
      <wilson-search-filter
        [debounceTime]="200"
        (modelChange)="onSearchChange($event)"
      ></wilson-search-filter>
      <nz-badge [nzCount]="(numberOfAppliedFilters$ | async) ?? undefined">
        <button nz-button nzType="default" (click)="openDrawer()">
          <fa-icon [icon]="faFilter"></fa-icon>
        </button>
      </nz-badge>
    </div>

    <div class="d-flex gap-2">
      <wilson-shared-user-qualifications-export-trigger></wilson-shared-user-qualifications-export-trigger>
      @if (
        'portal-complementary-certificate-button' | featureFlagPure | async
      ) {
        <wilson-shared-user-qualifications-complementary-certificate-export-trigger></wilson-shared-user-qualifications-complementary-certificate-export-trigger>
      }
    </div>
  </ng-container>
  <ng-container mainContent>
    <wilson-shared-user-qualifications-v2-list
      [searchFilter]="searchFilter"
      [partnerFilter]="partnerFilter"
      [userIdsFilter]="userFilter"
      [statusFilter]="statusFilter"
      [categoryFilter]="categoryFilter"
    >
    </wilson-shared-user-qualifications-v2-list>
  </ng-container>
</wilson-page-frame-v2>

<wilson-shared-user-qualifications-filter-drawer
  [isDrawerVisible]="isDrawerVisible"
  (closeDrawer)="isDrawerVisible = false"
  (applyFilters)="onApplyFilters($event)"
></wilson-shared-user-qualifications-filter-drawer>
